export class ConfirmDonationMailModel {
  to: string = null;
  subject: string = null;
  amount: number = 0;
  campaign: string = null;
  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}